import axios from './axios'

function service(endpoint) {

    function fetchProfile() {
        return axios.get(endpoint).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    function updateProfile(data) {
        return axios.put(endpoint, data).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    return {
        fetchProfile,
        updateProfile
    }
}

export default service
